"use client";
import { cn } from "cy-fe/src/utils/cn";
import { NextLink } from "cy-fe";
import { usePathname } from "next/navigation";
import { NavigationItem } from "../../navigation/models";
import { SendMoneyLink } from "./SendMoneyLink";
import { urls } from "../../urls";
import { ReactNode } from "react";
import { Phone } from "lucide-react";

export function StaticSidebar({
  navigation,
  logo,
  closeSidebar,
  footer,
}: {
  navigation: NavigationItem[];
  logo: ReactNode;
  footer?: ReactNode;
  closeSidebar: () => void;
}) {
  const pathName = usePathname();

  return (
    <div className="hidden pt-12 lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
      {/* Sidebar component, swap this element with another sidebar if you like */}
      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
        <div className="flex shrink-0 items-center justify-center">{logo}</div>
        <div className="flex justify-center pt-6">
          <SendMoneyLink
            href={urls.sendMoney.start.href}
            onClick={closeSidebar}
          />
        </div>
        <nav className="flex flex-1 flex-col pt-5">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul className="-mx-2 space-y-1">
                {navigation.map((item) => (
                  <li key={item.name}>
                    {typeof item.action === "string" ? (
                      <NextLink
                        className={cn(
                          "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-normal",
                          item.current(pathName)
                            ? "font-semibold text-black"
                            : "text-slate-600 hover:font-semibold hover:text-black",
                        )}
                        href={item.action}
                        onClick={closeSidebar}
                      >
                        <item.icon
                          aria-hidden="true"
                          className={cn(
                            item.current(pathName)
                              ? "text-black"
                              : "text-slate-600 group-hover:font-semibold group-hover:text-black",
                            "h-6 w-6 shrink-0",
                          )}
                        />
                        {item.name}
                      </NextLink>
                    ) : (
                      <button
                        className={cn(
                          "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-normal ring-black focus-visible:ring-2",
                          "text-slate-600 hover:font-semibold hover:text-black",
                        )}
                        onClick={() => {
                          (item.action as any)();
                          closeSidebar();
                        }}
                      >
                        <item.icon
                          aria-hidden="true"
                          className={cn(
                            "text-slate-600 group-hover:font-semibold group-hover:text-black",
                            "h-6 w-6 shrink-0",
                          )}
                        />
                        {item.name}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </nav>
        {footer}
      </div>
    </div>
  );
}
